import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks'; import PageLoader from '../../../../../components/PageLoader';
import GlobalStdCodeComponent from '../components/global-Std-codes.component';
import { selectGlobalStdCodesQueryItems } from '../../../../../redux/global-iship-cloud/global-std-codes/selector';
import { globalStdCodes } from '../../../../../redux/global-iship-cloud/global-std-codes/action';

const GlobalStdCode = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGlobalStdCodesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    stdCode,
    setStdCode
  ] = useState<any>({})

  const fetchRecordById = () => {
    dispatch(globalStdCodes.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-std-codes/fetch-detail`, entity: 'globalStdCodes', jsonData:
      {
        Context: {},
        Records: [
          {
            "GlobalStdcodeId": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchRecordById()
      }
    }, [])

  useEffect(
    () => {
      if (isQuery) {
        setStdCode(queryItems?.result?.items)
      }
    }, [isQuery])

  const handleInnerBasicFormChange: any = (event: any, field: string) => {
    setStdCode({ ...stdCode, [field]: event });
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {
      dispatch(globalStdCodes.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-std-codes`, entity: 'globalStdCodes', jsonData:
        {
          "Context": {},
          Records: [
            stdCode
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      dispatch(globalStdCodes.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-std-codes`, entity: 'globalStdCodes', jsonData:
        {
          "Context": {
          },
          Records: [
            stdCode
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = async () => {
    navigate(-1)
  }

  return (
    <>
      {queryItems?.isLoading ? <PageLoader /> :
        <GlobalStdCodeComponent
          stdCode={stdCode}
          handleFormSubmit={handleFormSubmit}
          back={back}
          handleInnerBasicFormChange={handleInnerBasicFormChange}
        />}
    </>
  )

}

export default GlobalStdCode;